// **React Imports
import { memo } from 'react'

// **MUI Imports
import { Box, FormLabel } from '@mui/material'

const FieldsetContainer = ({
  label,
  children,
  containerId = '',
  mb = 4,
  headerAction
}) => {
  return (
    <Box
      component="fieldset"
      sx={{
        border: '1px dashed var(--divider)',
        borderRadius: 2,
        padding: 3,
        margin: 0,
        width: '100%',
        minWidth: 0,
        mb: mb
      }}
      id={containerId}
    >
      <FormLabel
        component="legend"
        sx={{
          fontSize: 14,
          fontWeight: 'bold',
          px: 1,
          display: 'flex',
          alignItems: 'center',
          gap: 1.5
        }}
      >
        {label}
        {headerAction && (
          <Box component="span" sx={{ lineHeight: 0 }}>
            {headerAction}
          </Box>
        )}
      </FormLabel>

      {children}
    </Box>
  )
}

export default memo(FieldsetContainer)
